import { Download, Paperclip } from 'lucide-react';
import { FileUpload } from './FileUpload';
import { getUploadDownloadUrl, type UploadView } from '../uploads.api';

interface JobAttachmentsProps {
  jobId: string;
  attachments: UploadView[];
  onUploaded: () => void;
}

async function openDownload(uploadId: string) {
  const { url } = await getUploadDownloadUrl(uploadId);
  window.open(url, '_blank', 'noreferrer');
}

/** The original message / screenshot / release order attached as evidence (PRD → Job intake, requirement 3) — wraps the generic upload pipeline (gitaumoses4/chukua#16), scoped to this job. */
export function JobAttachments({ jobId, attachments, onUploaded }: JobAttachmentsProps) {
  return (
    <section className="mt-6 flex flex-col gap-3 border-t border-line pt-6">
      <h2 className="text-sm font-medium text-fg">Original message / evidence</h2>
      {attachments.length > 0 && (
        <ul className="flex flex-col gap-1.5">
          {attachments.map((attachment) => (
            <li key={attachment.id}>
              <button type="button" className="flex items-center gap-1.5 text-sm text-link" onClick={() => openDownload(attachment.id)}>
                <Paperclip className="size-4" />
                Attached {new Date(attachment.confirmedAt ?? attachment.createdAt).toLocaleString()}
                <Download className="size-3.5" />
              </button>
            </li>
          ))}
        </ul>
      )}
      <FileUpload entityType="job" entityId={jobId} onUploaded={onUploaded} />
    </section>
  );
}
